/** Base URL for portal API routes (no trailing slash). Defaults to same-origin `/api`. */
export function getApiBaseUrl() {
    const configured = window.API_BASE_URL?.trim();
    if (configured) {
        return configured.replace(/\/+$/, '');
    }
    return '/api';
}
export function getReferralsApiUrl(path) {
    const base = getApiBaseUrl();
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${base}${normalizedPath}`;
}
